import { CampaignTerminalsViewForm } from "src/app/features/Campaign/components/forms/CampaignTerminalsViewForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../components/FeatureButtons/CancelButton";
import { useFormSubmitTrigger } from "../../../../components/Form/hooks/useFormSubmitTrigger";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";

export const CampaignTerminalsViewFormPage = () => {
    const { runSubmit, formAction } = useFormSubmitTrigger();

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.campaignsViewFormPage" />
                <ActionBar>
                    <CancelButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.CAMPAIGNS}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <CampaignTerminalsViewForm runSubmit={runSubmit} formAction={formAction} />
            </FPageContent>
        </FPage>
    );
};
